module.exports = __webpack_public_path__ + "static/event_6-55ca3b9681c8d4bf7b73e7a65b4be3e9.png";